import React from "react";

function Dashboard() {
  return (
    <div className="page">
      <h1>Хяналтын самбар</h1>
      <p>Тавтай морилно уу!</p>
    </div>
  );
}

export default Dashboard;
